import { cloneDeep } from "lodash";
import { SerieTypeEnum } from "./types";
import { ChartSelectValueFormatKind, DisplayValueType } from "store/current-dashboard/types";
const mapProvidedSeries = (params, args) => {
    if (args.context.staticData.customResult?.length) {
        return;
    }
    params.forEach((param) => {
        if (!param.type) {
            throw new Error(`Invalid timeseries visitor param: type is required in ${JSON.stringify(param)}`);
        }
        if (!Object.values(SerieTypeEnum).includes(param.type) && param.type !== "yaxis" && param.type !== "plotOptions") {
            throw new Error(`Invalid timeseries visitor param: type "${param.type}" is not implemented`);
        }
    });
    args.context.staticData.customResult = cloneDeep(params);
};
const createSerieIfNotExists = (dimensionDatapoint, serieBase, element, series) => {
    if (element.measures &&
        element.measures[dimensionDatapoint] &&
        series &&
        !series.some((x) => element.measures && x.id === element.measures[dimensionDatapoint])) {
        const newSerie = {
            ...serieBase,
            id: element.measures[dimensionDatapoint],
            name: element.measures[dimensionDatapoint]
        };
        series.push(newSerie);
    }
};
const mutateResponseToAddMeasure = (element, params) => {
    if (element.measures && Number.isFinite(element.measures[params.measureDatapoint])) {
        if (element.measures[params.dimensionDatapoint]) {
            const received = element.measures[params.dimensionDatapoint]?.toString() || "";
            element.measures[received] = element.measures[params.measureDatapoint];
        }
    }
};
const getPlaceholderSerie = (args, params, selectedValues, dataSelectProps) => {
    const placeHolderSerie = {
        id: params.dimensionDatapoint,
        name: params.measureDatapoint,
        type: args.context.widgetState?.chartSeriesTypes
            ? args.context.widgetState?.chartSeriesTypes[0]
            : SerieTypeEnum.column,
        valueFormat: ChartSelectValueFormatKind.amount,
        yAxis: 0
    };
    if (selectedValues && selectedValues[0] && dataSelectProps && dataSelectProps[0]) {
        const valueFormat = dataSelectProps[0].selectValues[selectedValues[0]]?.valueFormat;
        if (valueFormat || valueFormat === ChartSelectValueFormatKind.value) {
            placeHolderSerie.valueFormat = valueFormat;
        }
    }
    if (args.context.widgetState?.displayValueType === DisplayValueType.Percent) {
        placeHolderSerie.valueFormat = ChartSelectValueFormatKind.percent;
    }
    if (args.context.widgetState?.displayValueType === DisplayValueType.Percent && placeHolderSerie.type === SerieTypeEnum.column) {
        placeHolderSerie.max = 1;
    }
    return placeHolderSerie;
};
const createSeriesFromResponse = (params, args) => {
    if (!params.dimensionDatapoint || !params.measureDatapoint) {
        throw new Error(`${JSON.stringify(params)} is missing required params`);
    }
    const element = args.visitable;
    if (params.exclude?.includes(element.measures?.[params.dimensionDatapoint])) {
        return;
    }
    const selectedValues = args.context.widgetState?.selectedValues;
    const dataSelectProps = args.context.componentProps?.dataSelectProps;
    const placeHolderSerie = getPlaceholderSerie(args, params, selectedValues, dataSelectProps);
    createSerieIfNotExists(params.dimensionDatapoint, placeHolderSerie, element, args.context?.staticData?.customResult);
    mutateResponseToAddMeasure(element, params);
};
export const highchartsTimeSeriesCreation = (params) => (args) => {
    const parameters = params;
    if (!args.context.staticData.customResult) {
        args.context.staticData.customResult = [];
    }
    if (parameters?.series?.length) {
        // Series are provided: map them
        mapProvidedSeries(parameters.series, args);
    }
    else if (parameters?.seriesDiscovery) {
        // Series needs to be created from responses
        createSeriesFromResponse(parameters.seriesDiscovery, args);
    }
};
